import { Badge, Avatar, Tooltip, HStack } from '@genial/components';
import { ColorTypes } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

interface TableContentItemBadgeProps {
  children: string;
  forceDesktop?: boolean;
}

const colorOptions = ['moderado', 'agressivo', 'conservador', 'arrojado'];

const getRiskColor = (value: string) => {
  const color = value.toLowerCase();

  const backgroundColor = (
    colorOptions.includes(color) ? `risk.${color}` : 'risk.conservador'
  ) as ColorTypes.Option;

  return backgroundColor;
};

export const TableContentItemBadge: React.FC<TableContentItemBadgeProps> = ({
  children = 'conservador',
  forceDesktop,
}) => {
  const isDesktopLayout = useBreakpointValue({ base: false, sm: false, lg: true });
  const isDesktop = forceDesktop ?? isDesktopLayout;
  const backgroundColor = getRiskColor(children);

  if (isDesktop) {
    return (
      <HStack>
        <Badge testId="table-content-item-badge" backgroundColor={backgroundColor}>
          {children}
        </Badge>
      </HStack>
    );
  }

  return (
    <Tooltip label={children}>
      <Box>
        <Avatar
          testId="suitability"
          bgColor={backgroundColor}
          textColor="neutral.white"
          initials={children}
        />
      </Box>
    </Tooltip>
  );
};
